import { DSNCImgComparison } from 'shared-definitions/types'
import { ApiComponentImageComparison } from 'data-source/types.wp'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

export function ncImgComparison(
  input: ApiComponentImageComparison,
  opts: PLinkMapperOpts
): DSNCImgComparison | [] {
  const aImage = imageMapper(input.first_image.image, opts)
  const bImage = imageMapper(input.second_image.image, opts)
  if (!aImage || !bImage) {
    return []
  }

  return {
    resource: 'nc-img-comparison',
    size: aImage.size ?? { w: 1920, h: 1080 },
    a: {
      image: aImage,
      title: input.first_image.description ?? '',
    },
    b: {
      image: bImage,
      title: input.second_image.description ?? '',
    },
  }
}
